import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><path d="M3.5 1A2.495 2.495 0 001 3.5v5C1 9.885 2.115 11 3.5 11h6.375L13 15v-4.063A2.486 2.486 0 0015 8.5v-5C15 2.115 13.885 1 12.5 1z" fill="#474747" /></svg>;
}

export default SvgComponent;